export const APP_INSIGHTS_DIAGNOSTICS_CONNECTION_STEP = {
  // [RD] = Remote Diagnostics

  // prerequisites (events that happen before connection sequence and/or during connection)
  START_POLLING_LOGICAL_LINK_LIST: '[RD] START POLLING LOGICAL LINK LIST',

  FETCH_GATEWAY_REMOTE_DIAGNOSTICS_FEATURE_ATTEMPT:
    '[RD] FETCH GATEWAY REMOTE DIAGNOSTICS FEATURE ATTEMPT',
  FETCH_GATEWAY_REMOTE_DIAGNOSTICS_FEATURE_SUCCESS:
    '[RD] FETCH GATEWAY REMOTE DIAGNOSTICS FEATURE SUCCESS',
  FETCH_GATEWAY_REMOTE_DIAGNOSTICS_FEATURE_FAILED:
    '[RD] FETCH GATEWAY REMOTE DIAGNOSTICS FEATURE FAILED',

  // connection reason
  SAVE_CONNECTION_REASON_ATTEMPT: '[RD] SAVE CONNECTION REASON ATTEMPT',
  SAVE_CONNECTION_REASON_SUCCESS: '[RD] SAVE CONNECTION REASON SUCCESS',
  SAVE_CONNECTION_REASON_FAILED: '[RD] SAVE CONNECTION REASON FAILED',

  // start
  START_CONNECTION_SEQUENCE: '0. [RD] START CONNECTION SEQUENCE',

  // step
  GET_FREE_DIAGSTACK_INSTANCE_ATTEMPT: `[RD] GET FREE DIAGTACK INSTANCE ATTEMPT`,
  GET_FREE_DIAGSTACK_INSTANCE_SUCCESS: `[RD] GET FREE DIAGTACK INSTANCE SUCCESS`,
  GET_FREE_DIAGSTACK_INSTANCE_FAILED: `[RD] GET FREE DIAGTACK INSTANCE FAILED`,

  START_POLLING_GATEWAY_REMOTE_DIAGNOSTICS_FEATURE:
    '[RD] START POLLING GATEWAY REMOTE DIAGNOSTICS FEATURE',
  VALUE_OF_GATEWAY_REMOTE_DIAGNOSTICS_FEATURE: '[RD] VALUE OF GATEWAY REMOTE DIAGNOSTICS FEATURE',

  CLOSE_EXISTING_SESSION_ATTEMPT: `[RD] CLOSE EXISTING SESSION ATTEMPT`,
  CLOSE_EXISTING_SESSION_SUCCESS: `[RD] CLOSE EXISTING SESSION SUCCESS`,
  CLOSE_EXISTING_SESSION_FAILED: `[RD] CLOSE EXISTING SESSION FAILED`,

  LOGIN_ATTEMPT: `[RD] LOGIN ATTEMPT`,
  LOGIN_SUCCESS: `[RD] LOGIN SUCCESS`,
  LOGIN_FAILED: `[RD] LOGIN FAILED`,

  OPEN_SESSION_ATTEMPT: `[RD] OPEN SESSION ATTEMPT`,
  OPEN_SESSION_SUCCESS: `[RD] OPEN SESSION SUCCESS`,
  OPEN_SESSION_FAILED: `[RD] OPEN SESSION FAILED`,

  GATEWAY_REMOTE_DIAGNOSTICS_OPEN_COMMAND_ATTEMPT:
    '[RD] INVOKE GATEWAY REMOTE DIAGNOSTICS OPEN COMMAND ATTEMPT',
  GATEWAY_REMOTE_DIAGNOSTICS_OPEN_COMMAND_SUCCESS:
    '[RD] INVOKE GATEWAY REMOTE DIAGNOSTICS OPEN COMMAND SUCCESS',
  GATEWAY_REMOTE_DIAGNOSTICS_OPEN_COMMAND_FAILED:
    '[RD] INVOKE GATEWAY REMOTE DIAGNOSTICS OPEN COMMAND FAILED',

  REGISTER_REMOTE_VCI_ATTEMPT: '[RD] REMOTE VCI REGISTER ATTEMPT',
  REGISTER_REMOTE_VCI_SUCCESS: '[RD] REMOTE VCI REGISTER SUCCESS',
  REGISTER_REMOTE_VCI_FAILED: '[RD] REMOTE VCI REGISTER FAILED',

  REMOTE_VCI_AVAILABILITY_CHECK_ATTEMPT: '[RD] REMOTE VCI AVAILABILITY CHECK ATTEMPT',
  REMOTE_VCI_AVAILABILITY_CHECK_SUCCESS: '[RD] REMOTE VCI AVAILABILITY CHECK SUCCESS',
  REMOTE_VCI_AVAILABILITY_CHECK_RESPONSE_EMPTY: '[RD] REMOTE VCI AVAILABILITY CHECK RESPONSE_EMPTY',
  REMOTE_VCI_AVAILABILITY_CHECK_FAILED: '[RD] REMOTE VCI AVAILABILITY CHECK FAILED',

  REMOTE_VCI_CONNECT_ATTEMPT: '[RD] REMOTE VCI CONNECT ATTEMPT',
  REMOTE_VCI_CONNECT_SUCCESS: '[RD] REMOTE VCI CONNECT SUCCESS',
  REMOTE_VCI_CONNECT_FAILED: '[RD] REMOTE VCI CONNECT FAILED',

  SETUP_INFO_ATTEMPT: `[RD] SETUP INFO ATTEMPT`,
  SETUP_INFO_SUCCESS: `[RD] SETUP INFO SUCCESS`,
  SETUP_INFO_FAILED: `[RD] SETUP INFO FAILED`,

  MAIN_LOGICAL_LINK_OPEN_ATTEMPT: '[RD] MAIN LOGICAL LINK OPEN ATTEMPT',
  MAIN_LOGICAL_LINK_OPEN_SUCCESS: '[RD] MAIN LOGICAL LINK OPEN SUCCESS',
  MAIN_LOGICAL_LINK_OPEN_FAILED: '[RD] MAIN LOGICAL LINK OPEN FAILED',

  FETCH_PRODUCT_MATRIX_ATTEMPT: '[RD] FETCH PRODUCT MATRIX ATTEMPT',
  FETCH_PRODUCT_MATRIX_SUCCESS: '[RD] FETCH PRODUCT MATRIX SUCCESS',
  FETCH_PRODUCT_MATRIX_FAILED: '[RD] FETCH PRODUCT MATRIX FAILED',
  FETCH_PRODUCT_MATRIX_INCORRECT_DATA: '[RD] FETCH PRODUCT MATRIX INCORRECT_DATA',

  OPEN_DEVICE_MAIN_LOGICAL_LINK_ATTEMPT: '[RD] OPEN_DEVICE_MAIN_LOGICAL_LINK ATTEMPT',
  OPEN_DEVICE_MAIN_LOGICAL_LINK_SUCCESS: '[RD] OPEN_DEVICE_MAIN_LOGICAL_LINK SUCCESS',
  OPEN_DEVICE_MAIN_LOGICAL_LINK_FAILED: '[RD] OPEN_DEVICE_MAIN_LOGICAL_LINK FAILED',

  FETCH_TOPOLOGY_ATTEMPT: '[RD] FETCH TOPOLOGY ATTEMPT',
  FETCH_TOPOLOGY_SUCCESS: '[RD] FETCH TOPOLOGY SUCCESS',
  FETCH_TOPOLOGY_FAILED: '[RD] FETCH TOPOLOGY FAILED',

  MAIN_LOGICAL_LINK_CLOSE_ATTEMPT: '[RD] MAIN LOGICAL LINK CLOSE ATTEMPT',
  MAIN_LOGICAL_LINK_CLOSE_SUCCESS: '[RD] MAIN LOGICAL LINK CLOSE SUCCESS',
  MAIN_LOGICAL_LINK_CLOSE_FAILED: '[RD] MAIN LOGICAL LINK CLOSE FAILED',

  MAIN_LOGICAL_LINK_FROM_TOPOLOGY_OPEN_ATTEMPT: '[RD] MAIN LOGICAL LINK FROM TOPOLOGY OPEN ATTEMPT',
  MAIN_LOGICAL_LINK_FROM_TOPOLOGY_OPEN_SUCCESS: '[RD] MAIN LOGICAL LINK FROM TOPOLOGY OPEN SUCCESS',
  MAIN_LOGICAL_LINK_FROM_TOPOLOGY_OPEN_FAILED: '[RD] MAIN LOGICAL LINK FROM TOPOLOGY OPEN FAILED',

  GET_ACTIVE_DTC_ATTEMPT: '[RD] GET ACTIVE DTC ATTEMPT',
  GET_ACTIVE_DTC_SUCCESS: '[RD] GET ACTIVE DTC SUCCESS',
  GET_ACTIVE_DTC_FAILED: '[RD] GET ACTIVE DTC FAILED',

  GET_ACTIVE_SESSIONS_ATTEMPT: '[RD] GET ACTIVE SESSIONS ATTEMPT',
  GET_ACTIVE_SESSIONS_SUCCESS: '[RD] GET ACTIVE SESSIONS SUCCESS',
  GET_ACTIVE_SESSIONS_FAILED: '[RD] GET ACTIVE SESSIONS FAILED',
  GET_ACTIVE_SESSIONS_EMPTY: '[RD] GET ACTIVE SESSIONS EMPTY',

  UPDATE_ACTIVE_SESSIONS_ATTEMPT: '[RD] UPDATE ACTIVE SESSIONS ATTEMPT',
  UPDATE_ACTIVE_SESSIONS_SUCCESS: '[RD] UPDATE ACTIVE SESSIONS SUCCESS',
  UPDATE_ACTIVE_SESSIONS_FAILED: '[RD] UPDATE ACTIVE SESSIONS FAILED',

  CONNECTION_STATUS_CONNECTED: '[RD] CONNECTION STATUS: ACTIVE',
  CONNECTION_STATUS_FAILED: '[RD] CONNECTION STATUS: FAILED',
  CONNECTION_STATUS_INACTIVE: '[RD] CONNECTION STATUS: INACTIVE',
};

export const APP_INSIGHTS_DIAGNOSTICS_OPERATIONS = {
  OPEN_LOGICAL_LINK_ATTEMPT: '[RD] OPEN LOGICAL LINK ATTEMPT',
  OPEN_LOGICAL_LINK_SUCCESS: '[RD] OPEN LOGICAL LINK SUCCESS',
  OPEN_LOGICAL_LINK_FAILED: '[RD] OPEN LOGICAL LINK FAILED',

  VDD_READ_VIA_REST_ATTEMPT: '[RD] VDD READ VIA REST ATTEMPT',
  VDD_READ_VIA_REST_SUCCESS: '[RD] VDD READ VIA REST SUCCESS',
  VDD_READ_VIA_REST_FAILED: '[RD] VDD READ VIA REST FAILED',

  DISCONNECT_ATTEMPT: '[RD] DISCONNECT ATTEMPT',
  DISCONNECT_SUCCESS: '[RD] DISCONNECT SUCCESS',
  DISCONNECT_FAILED: '[RD] DISCONNECT FAILED',
};

export const APP_INSIGHTS_HYDRAULIC_SCHEME = {
  // [HS] = Hydralic Scheme
  GET_HYDRAULIC_MATRIX_CODE_FAILED: '[HS] GET HYDRAULIC MATRIX CODE FAILED',
  GET_HYDRAULIC_SCHEME_FAILED: '[HS] GET HYDRAULIC SCHEME FAILED',
};
